import {
  ChangesSavedNotification,
  GeneralErrorNotification,
} from '@storeOld/reducers/notification'
import { call, put, select } from 'redux-saga/effects'

import { type InboxActions, InternalInboxActions } from '../actions'
import { inboxClient } from '../client'
import { selectProjectSettings } from '../selectors'
import type { ProjectNotificationSettingsView } from '../types'

export function* fetchProjectSettings({
  payload: { projectId },
}: ReturnType<typeof InboxActions.fetchProjectSettings>) {
  try {
    const settings: ProjectNotificationSettingsView = yield call(
      inboxClient.getSettings,
      projectId
    )

    yield put(
      InternalInboxActions.projectSettingsLoaded({ projectId, settings })
    )
  } catch (error) {
    console.error('Error loading project notification settings:', error)

    yield put(GeneralErrorNotification)
  }
}

// Shown as saved at once; the server's answer replaces it, and a failure
// puts the last known settings back
export function* saveProjectSettings({
  payload: { projectId, settings },
}: ReturnType<typeof InboxActions.saveProjectSettings>) {
  const current: ProjectNotificationSettingsView | null = yield select(
    selectProjectSettings(projectId)
  )
  const digestDefault = current?.digestDefault ?? false

  yield put(
    InternalInboxActions.projectSettingsLoaded({
      projectId,
      settings: { ...settings, digestDefault },
    })
  )

  try {
    const saved: ProjectNotificationSettingsView = yield call(
      inboxClient.putSettings,
      projectId,
      settings
    )

    yield put(
      InternalInboxActions.projectSettingsLoaded({ projectId, settings: saved })
    )
    yield put(ChangesSavedNotification)
  } catch (error) {
    console.error('Error saving project notification settings:', error)

    if (current) {
      yield put(
        InternalInboxActions.projectSettingsLoaded({
          projectId,
          settings: current,
        })
      )
    }
    yield put(GeneralErrorNotification)
  }
}
